export const transformUserAdditionalInfoData = (data, backData) => {
  const userAgent = backData["userAgentJs"];
  const userAgentJs = backData["userAgent"];

  return data.map(group =>
    group.map(item => {
      if (item.id === "userAgent") {
        return {
          ...item,
          label: null,
          value: userAgent,
        };
      }
      if (item.id === "userAgentJs") {
        if (userAgent === userAgentJs) {
          return {
            ...item,
            label: "The same",
            value: "",
          };
        } else {
          return {
            ...item,
            label: null,
            value: userAgentJs,
          };
        }
      }

      return {
        ...item,
        value: backData[item.id],
      };
    }),
  );
};
